import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "ae-page"
};
var _hoisted_2 = {
  id: "map",
  class: "ae-map",
  style: {
    "border-radius": "6px",
    "height": "254px",
    "background-color": "#45a57d"
  }
};
var _hoisted_3 = {
  class: "row"
};
var _hoisted_4 = {
  class: "row"
};
var _hoisted_5 = {
  class: "row"
};
var _hoisted_6 = {
  class: "row"
};
var _hoisted_7 = {
  class: "row"
};
var _hoisted_8 = {
  class: "row"
};
var _hoisted_9 = {
  class: "row"
};
var _hoisted_10 = {
  class: "row"
};
var _hoisted_11 = {
  class: "ae-bottom"
};
import { ref, computed, onMounted, nextTick } from "vue";
import { Toast, Search as VanSearch } from "vant";
import Button from "@/components/base/Button.vue";
import Input from "@/components/base/Input.vue";
import GoogleMapHelper from "@/utils/googleMapHelper";
import { useAddressStoreWithOut } from "@/store/addressStore";
import { useRouter } from "@/hooks/useRouter";
import Dialog from "@/components/dialog/dialog";
import { showToast } from "@/utils/toastUtil";
import { useUserStore } from "@/store/userStore";
import { hideLoading, showLoading } from "@/utils/loadingUtil";
import { formatLocation } from "@/utils/format";
import { useI18n } from "vue-i18n";
import { getCountry } from "../../utils/authUtil";
import { isFunction } from "@/utils/isUtil";
export default {
  __name: 'AddressEdit',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var _useRouter = useRouter(),
      routerBack = _useRouter.routerBack,
      router = _useRouter.router,
      routerGo = _useRouter.routerGo;
    var addressStore = useAddressStoreWithOut();
    var userStore = useUserStore();

    // const handlePageBack = () => {
    //   // 如果地址列表长度为0,说明是连跳进来的,向上返回2级
    //   if (addressStore.getAddressList.length === 0) {
    //     routerGo(-2);
    //   } else {
    //     routerBack();
    //   }
    // };

    var selectedId = ref("");
    var searchValue = ref("");
    var addressDetail = ref({
      contact_name: "",
      // 姓名
      contact_number: "",
      // 电话
      // label: "", // label
      location: {
        coordinate: {
          longitude: 0,
          // 经度
          latitude: 0 // 纬度
        },
        site: "",
        // landMark/building name
        detail: "",
        // 地址详情/unit no
        street: "",
        // 填入街道
        city: "",
        // 填入市
        state: "",
        // 填入省
        postcode: "",
        // 填入邮编
        country: "" // 填入国家
      },
      notes: "" // 备注
    });
    var isShowMapAndForm = ref(false); // 是否显示地图与表单
    var mapHelper = ref(null);
    var mapMarker = null;
    var isSaveAble = computed(function () {
      var addressDetailObj = addressDetail.value;
      return addressDetailObj.contact_name && addressDetailObj.contact_number
      // &&
      // addressDetailObj.label &&
      // addressDetailObj.location.detail
      ;
    });
    var getDeliveryDetail = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(coordinate, site) {
        var lat, lng, address, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              lat = isFunction(coordinate.lat) ? coordinate.lat() : coordinate.lat;
              lng = isFunction(coordinate.lng) ? coordinate.lng() : coordinate.lng;
              _context.next = 5;
              return mapHelper.value.reverseGeocoding({
                lat: lat,
                lng: lng
              });
            case 5:
              address = _context.sent;
              if (!address) {
                _context.next = 11;
                break;
              }
              res = _objectSpread(_objectSpread({}, formatAddressComponentToAddressDetail(address.address_components)), {}, {
                site: site || "",
                detail: "",
                coordinate: {
                  latitude: lat,
                  longitude: lng
                }
              });
              addressDetail.value.location = res;
              // 搜索框回显
              searchValue.value = formatLocation(res);
              return _context.abrupt("return", res);
            case 11:
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              console.error("[getDeliveryDetail error]:", _context.t0);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 13]]);
      }));
      return function getDeliveryDetail(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    var formatAddressComponentToAddressDetail = function formatAddressComponentToAddressDetail(addressComponents) {
      var findKeyValueMap = {
        street: "route",
        city: "locality",
        postcode: "postal_code",
        state: "administrative_area_level_1",
        country: "country"
      };
      var result = {
        street: "",
        city: "",
        postcode: "",
        state: "",
        country: ""
      };
      addressComponents.forEach(function (component) {
        var _loop = function _loop() {
          var targetType = findKeyValueMap[key];
          if (component.types.find(function (type) {
            return type === targetType;
          })) {
            result[key] = component.long_name;
            delete findKeyValueMap[key];
            return 1; // break
          }
        };
        for (var key in findKeyValueMap) {
          if (_loop()) break;
        }
      });
      return result;
    };
    var handleMoveMarker = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getDeliveryDetail(event.latLng);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function handleMoveMarker(_x3) {
        return _ref2.apply(this, arguments);
      };
    }();
    var initAutocomplete = function initAutocomplete() {
      var mh = mapHelper.value;
      mh.initAutocomplete("place-search", /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(place) {
          var res;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!place.address_components || !place.geometry)) {
                  _context3.next = 2;
                  break;
                }
                return _context3.abrupt("return");
              case 2:
                _context3.next = 4;
                return getDeliveryDetail(place.geometry.location, place.name);
              case 4:
                res = _context3.sent;
                if (res) {
                  if (!isShowMapAndForm.value) {
                    // 之前还没有创建地图,需要从头initMap

                    initMap({
                      lat: res.coordinate.latitude,
                      lng: res.coordinate.longitude
                    }).then(function () {
                      isShowMapAndForm.value = true;
                    }).catch(function (e) {
                      console.error(e);
                      showToast(t("loadGoogleMapServiceError"));
                    });
                  } else {
                    // 已创建地图的情况,直接setCenter即可
                    mapHelper.value.setCenter({
                      lat: res.coordinate.latitude,
                      lng: res.coordinate.longitude
                    });
                    if (mapHelper.value) {
                      // 已有marker
                      mapHelper.value.removeMarker(mapMarker);
                    }
                    mapMarker = mapHelper.value.addMarker({
                      lat: res.coordinate.latitude,
                      lng: res.coordinate.longitude
                    }, {
                      draggable: true
                    });
                    google.maps.event.addListener(mapMarker, "dragend", handleMoveMarker);
                  }
                }
              case 6:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x4) {
          return _ref3.apply(this, arguments);
        };
      }());
    };
    var handleUseCurCoordinate = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var coordinate, res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              showLoading();
              _context4.next = 3;
              return mapHelper.value.getCurrentPositionByH5();
            case 3:
              res = _context4.sent;
              if (res.isOK && res.data) {
                userStore.setCoordinate(res.data);
                coordinate = userStore.getCoordinate;
              } else if (userStore.getCoordinate) {
                coordinate = userStore.getCoordinate;
              }
              if (!coordinate) {
                _context4.next = 11;
                break;
              }
              // 根据坐标设置地图
              if (!isShowMapAndForm.value) {
                // 之前还没有创建地图,需要从头initMap
                initMap({
                  lat: coordinate.lat,
                  lng: coordinate.lng
                }).then(function () {
                  isShowMapAndForm.value = true;
                }).catch(function (e) {
                  showToast(t("loadGoogleMapServiceError"));
                });
              } else {
                // 已创建地图的情况,直接setCenter即可
                mapHelper.value.setCenter({
                  lat: coordinate.lat,
                  lng: coordinate.lng
                });
                if (mapHelper.value) {
                  // 已有marker
                  mapHelper.value.removeMarker(mapMarker);
                }
                mapMarker = mapHelper.value.addMarker({
                  lat: coordinate.lat,
                  lng: coordinate.lng
                }, {
                  draggable: true
                });
                google.maps.event.addListener(mapMarker, "dragend", handleMoveMarker);
              }
              // 填充地址详情
              _context4.next = 9;
              return getDeliveryDetail(coordinate);
            case 9:
              _context4.next = 12;
              break;
            case 11:
              showToast(t("failedToGetLocation"));
            case 12:
              hideLoading();
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function handleUseCurCoordinate() {
        return _ref4.apply(this, arguments);
      };
    }();
    var initMap = function initMap(coordinate) {
      return new Promise(function (resolve, reject) {
        mapHelper.value.initMap("map", {
          center: coordinate,
          zoom: 12,
          disableDefaultUI: true
        }, function (e) {
          if (e) {
            reject(e);
            return;
          }
          if (mapHelper.value) {
            // 已有marker
            mapHelper.value.removeMarker(mapMarker);
          }
          mapMarker = mapHelper.value.addMarker({
            lat: coordinate.lat,
            lng: coordinate.lng
          }, {
            draggable: true
          });
          google.maps.event.addListener(mapMarker, "dragend", handleMoveMarker);
          resolve(true);
        });
      });
    };
    var handleUpdateContactNumber = function handleUpdateContactNumber(val) {
      addressDetail.value.contact_number = val;
      nextTick(function () {
        var value = addressDetail.value.contact_number;
        // 过滤非法字符
        value = value.replace(/[\D]/g, "");
        addressDetail.value.contact_number = value;
      });
    };
    var validator = function validator() {
      if (addressDetail.value.contact_number.length < 7) {
        showToast(t("pleaseInputACorrectTelNumber"));
        return false;
      }
      return true;
    };
    var handleDisabledSave = function handleDisabledSave() {
      showToast(t("pleaseFillInTheCompleteAddressInformation"));
    };
    var handleSave = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (validator()) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              showLoading();
              if (!selectedId.value) {
                _context5.next = 8;
                break;
              }
              _context5.next = 6;
              return addressStore.updateAddress(addressDetail.value);
            case 6:
              _context5.next = 10;
              break;
            case 8:
              _context5.next = 10;
              return addressStore.addAddress(addressDetail.value);
            case 10:
              hideLoading();
              routerBack();
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function handleSave() {
        return _ref5.apply(this, arguments);
      };
    }();
    var handleDelete = function handleDelete() {
      // addressStore.deleteAddress(selectedId.value);
      // routerBack();
      // test.value = true;
      Dialog.confirm({
        title: t("deleteThisAddress"),
        desc: t("areYouSureToDeleteThisAddress"),
        okText: t("yes"),
        onOk: function () {
          var _onOk = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
            return _regeneratorRuntime().wrap(function _callee6$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  showLoading();
                  _context6.next = 3;
                  return addressStore.deleteAddress(selectedId.value);
                case 3:
                  hideLoading();
                  routerBack();
                case 5:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          }));
          function onOk() {
            return _onOk.apply(this, arguments);
          }
          return onOk;
        }(),
        cancelText: t("no")
      });
    };
    onMounted(function () {
      mapHelper.value = new GoogleMapHelper({
        countryCode: getCountry()
      });
      mapHelper.value.initMap(undefined, undefined, function () {
        initAutocomplete();
      });
      if (router.currentRoute.value.query) {
        var targetId = router.currentRoute.value.query.id || "";
        var targetAddress = addressStore.getAddressList.find(function (item) {
          return item.id === targetId;
        });
        if (targetAddress) {
          selectedId.value = targetId;
          addressDetail.value = JSON.parse(JSON.stringify(targetAddress));
          initMap({
            lat: targetAddress.location.coordinate.latitude,
            lng: targetAddress.location.coordinate.longitude
          }).then(function () {
            isShowMapAndForm.value = true;
          }).catch(function (e) {
            console.error(e);
            showToast(t("loadGoogleMapServiceError"));
          });
        }
      }
    });
    return function (_ctx, _cache) {
      var _component_SvgIcon = _resolveComponent("SvgIcon");
      var _component_Page = _resolveComponent("Page");
      return _openBlock(), _createBlock(_component_Page, {
        title: selectedId.value ? _ctx.$t('editAddress') : _ctx.$t('addNewAddress'),
        class: "ae-ctn",
        "show-footer": ""
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_11, [_createVNode(Button, {
            disabled: !isSaveAble.value,
            class: "btn",
            onClick: handleSave,
            onDisabledClick: handleDisabledSave
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("save")), 1)];
            }),
            _: 1
          }, 8, ["disabled"]), selectedId.value ? (_openBlock(), _createBlock(Button, {
            key: 0,
            type: "border",
            class: "btn",
            onClick: handleDelete
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("deleteAddress")), 1)];
            }),
            _: 1
          })) : _createCommentVNode("", true)])];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(VanSearch), {
            id: "place-search",
            modelValue: searchValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return searchValue.value = $event;
            }),
            placeholder: _ctx.$t('enterYourStreetName'),
            "left-icon": require('@/assets/images/search.svg')
          }, null, 8, ["modelValue", "placeholder", "left-icon"]), _createVNode(Button, {
            class: "position-btn",
            type: "border",
            onClick: handleUseCurCoordinate
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_SvgIcon, {
                size: 20,
                class: "position-icon",
                name: "position",
                color: "#0000ff"
              }), _createElementVNode("span", null, _toDisplayString(_ctx.$t("useMyCurrentLocation")), 1)];
            }),
            _: 1
          }), _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [[_vShow, isShowMapAndForm.value]]), isShowMapAndForm.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("div", _hoisted_3, [_createVNode(Input, {
            modelValue: addressDetail.value.contact_name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return addressDetail.value.contact_name = $event;
            }),
            class: "row-item-1d2",
            label: _ctx.$t('yourName'),
            required: "",
            placeholder: _ctx.$t('yourName')
          }, null, 8, ["modelValue", "label", "placeholder"]), _createVNode(Input, {
            "model-value": addressDetail.value.contact_number,
            class: "row-item-1d2",
            label: _ctx.$t('yourTel'),
            required: "",
            placeholder: _ctx.$t('yourTel'),
            "onUpdate:modelValue": handleUpdateContactNumber
          }, null, 8, ["model-value", "label", "placeholder"])]), _createElementVNode("div", _hoisted_4, [_createVNode(Input, {
            modelValue: addressDetail.value.location.detail,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return addressDetail.value.location.detail = $event;
            }),
            label: _ctx.$t('unitNo'),
            placeholder: _ctx.$t('unitNo')
          }, null, 8, ["modelValue", "label", "placeholder"])]), _createElementVNode("div", _hoisted_5, [_createVNode(Input, {
            modelValue: addressDetail.value.location.site,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return addressDetail.value.location.site = $event;
            }),
            label: _ctx.$t('landmarkBuildingName'),
            placeholder: _ctx.$t('landmarkBuildingNameOptional')
          }, null, 8, ["modelValue", "label", "placeholder"])]), _createElementVNode("div", _hoisted_6, [_createVNode(Input, {
            modelValue: addressDetail.value.location.street,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return addressDetail.value.location.street = $event;
            }),
            disabled: "",
            label: _ctx.$t('streetName')
          }, null, 8, ["modelValue", "label"])]), _createElementVNode("div", _hoisted_7, [_createVNode(Input, {
            modelValue: addressDetail.value.location.city,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
              return addressDetail.value.location.city = $event;
            }),
            disabled: "",
            label: _ctx.$t('city')
          }, null, 8, ["modelValue", "label"])]), _createElementVNode("div", _hoisted_8, [_createVNode(Input, {
            modelValue: addressDetail.value.location.postcode,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
              return addressDetail.value.location.postcode = $event;
            }),
            class: "row-item-1d3",
            disabled: "",
            label: _ctx.$t('postCode')
          }, null, 8, ["modelValue", "label"]), _createVNode(Input, {
            modelValue: addressDetail.value.location.state,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
              return addressDetail.value.location.state = $event;
            }),
            class: "row-item-2d3",
            disabled: "",
            label: _ctx.$t('state')
          }, null, 8, ["modelValue", "label"])]), _createElementVNode("div", _hoisted_9, [_createVNode(Input, {
            modelValue: addressDetail.value.location.country,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
              return addressDetail.value.location.country = $event;
            }),
            disabled: "",
            label: _ctx.$t('country')
          }, null, 8, ["modelValue", "label"])]), _createElementVNode("div", _hoisted_10, [_createVNode(Input, {
            modelValue: addressDetail.value.notes,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
              return addressDetail.value.notes = $event;
            }),
            rows: "5",
            label: _ctx.$t('addNotes'),
            type: "textarea",
            placeholder: _ctx.$t('notes'),
            "self-type": "borderTextarea"
          }, null, 8, ["modelValue", "label", "placeholder"])])], 64)) : _createCommentVNode("", true)])];
        }),
        _: 1
      }, 8, ["title"]);
    };
  }
};